import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubjectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subject"}/>
}
